/* eslint-disable */
// File to store all constant values used across the system

import axios from "axios";



// API URLS
export const GLOBAL_URL = process.env.VUE_APP_GLOBAL_URL;



// Set axios defaults
axios.defaults.withCredentials = true;

export const get_token = () => sessionStorage.getItem("token");

// Safe cookie lookup for browser-based API calls.
export const getCookie = (name) => {
  if (!name || typeof document === "undefined") {
    return null;
  }

  const cookieString = document.cookie;
  if (!cookieString) {
    return null;
  }

  const cookiePrefix = `${encodeURIComponent(name)}=`;
  const matchedCookie = cookieString
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(cookiePrefix));

  if (!matchedCookie) {
    return null;
  }

  return decodeURIComponent(matchedCookie.slice(cookiePrefix.length));
};

export const get_csrf_token = () => getCookie("csrftoken");

export const get_auth_headers = () => {
  const token = get_token();
  const csrfToken = get_csrf_token();

  const headers = {
    ...(token ? { Authorization: `Token ${token}` } : {}),
    ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
  };

  return headers
};

// Reusable default headers for API calls.
export const get_headers = (extra_headers = {}) => ({
  "Content-Type": "application/json",
  ...get_auth_headers(),
  ...extra_headers,
});

// Optional helper when sending FormData or non-JSON payloads.
export const get_request_config = (extra_config = {}) => ({
  withCredentials: true,
  ...extra_config,
  headers: get_headers(extra_config.headers),
});

export const normalize_user_role = (role) => {
  if (!role) return role;
  const normalized = String(role).trim().replace(/\s+/g, " ");
  const lower = normalized.toLowerCase();

  if (
    lower === "system admin" ||
    lower === "system administrator" ||
    lower === "sys admin"
  ) {
    return "System Admin";
  }

  return normalized;
};

// SYSTEM URLS

// CLIENT BRANDING
const CLIENT_URL = `${GLOBAL_URL}/client`;
export const CLIENT_BRANDING = `${CLIENT_URL}/get_client_branding/`;

// USER MANAGEMENT
const SYSTEM_MANAGEMENT_URL = `${GLOBAL_URL}/system_management`;
export const OTP_SENT = `${SYSTEM_MANAGEMENT_URL}/otp_sent/`;
export const LOGIN_URL = `${SYSTEM_MANAGEMENT_URL}/login_user/`;
export const ENTER_OTP_VALUE = `${SYSTEM_MANAGEMENT_URL}/enter_otp_value/`;
export const SEND_FORGOT_PASSWORD_EMAIL = `${SYSTEM_MANAGEMENT_URL}/send_forgot_password_email/`;
export const FIRST_TIME_LOGIN_URL = `${SYSTEM_MANAGEMENT_URL}/first_time_login/`;
export const LINK_FORGOT_PASSWORD = `${SYSTEM_MANAGEMENT_URL}/link_forgot_password/`;
export const FORGOT_PASSWORD_RESET = `${SYSTEM_MANAGEMENT_URL}/forgot_password_reset/`;
export const GET_USERS = `${SYSTEM_MANAGEMENT_URL}/users/`;
export const CREATE_USER = `${SYSTEM_MANAGEMENT_URL}/create_user/`;
export const CREATE_ROLE = `${SYSTEM_MANAGEMENT_URL}/create_role/`;
export const UPDATE_ROLE = `${SYSTEM_MANAGEMENT_URL}/update_role/`;
export const UPDATE_USER = `${SYSTEM_MANAGEMENT_URL}/update_user/`;
export const DEACTIVATE_USER = `${SYSTEM_MANAGEMENT_URL}/deactivate_user/`;
export const ACTIVATE_USER = `${SYSTEM_MANAGEMENT_URL}/activate_user/`;
export const GET_USER_ROLES = `${SYSTEM_MANAGEMENT_URL}/get_user_roles/`;
export const GET_USER_ROLES_URL = `${SYSTEM_MANAGEMENT_URL}/get_user_roles/`;
export const CREATE_NEW_ENTITY_URL = `${SYSTEM_MANAGEMENT_URL}/create_new_entity/`;
export const CREATE_ENTITY_APPLICATION_ONLY_URL = `${SYSTEM_MANAGEMENT_URL}/create_entity_application_only_api/`;
export const LAUNCH_PLATFORM_URL = `${SYSTEM_MANAGEMENT_URL}/api/launch_platform/`;

// ACCESS CONTROLS
const ACCESS_CONTROLS_URL = `${GLOBAL_URL}/access_controls`;
export const ASSIGN_PROJECTS_TO_ROLES_URL = `${ACCESS_CONTROLS_URL}/assign_projects_to_roles/`;


//Project/Company Management URLs
export const PROJECT_MANGEMENT_URL = `${GLOBAL_URL}/project/`;
export const GET_COMPANY_TYPES = `${PROJECT_MANGEMENT_URL}get_project_types/`;
export const GET_COMPANIES = `${PROJECT_MANGEMENT_URL}get_projects/`;
export const VIEW_PROJECTS = `${PROJECT_MANGEMENT_URL}view_projects/`;
export const CREATE_COMPANY = `${PROJECT_MANGEMENT_URL}create_project/`;
export const EDIT_PROJECT = `${PROJECT_MANGEMENT_URL}edit_projects/`;
export const ASSIGN_USER_TO_PROJECT = `${PROJECT_MANGEMENT_URL}assign_users/`;
export const CREATE_MANUAL_COMPLIANCE_TASK = `${PROJECT_MANGEMENT_URL}create_manual_compliance_task/`;
export const GET_PROJECT_ENGAGENET_MANAGE_URL = `${PROJECT_MANGEMENT_URL}get_project_engagenet_manage_url/`;


// ENTITY MANAGEMENT
const ENTITY_MANAGEMENT_URL = `${GLOBAL_URL}/entity_management`;
const ENTITY_MANAGEMENT_API_URL = `${GLOBAL_URL}/entity_management_api`;
export const CREATE_ENTITY_TYPE_URL = `${ENTITY_MANAGEMENT_URL}/create_entity_type/`;
export const UPDATE_ENTITY_TYPE_URL = `${ENTITY_MANAGEMENT_URL}/update_entity_type/`;
export const GET_ENTITY_TYPE_CATEGORIES_URL = `${ENTITY_MANAGEMENT_URL}/get_entity_type_categories/`;
export const VIEW_ENTITY_TYPE_URL = `${ENTITY_MANAGEMENT_URL}/view_entity_type/`;
export const APPLY_FOR_ENTITY_TYPE_URL = `${ENTITY_MANAGEMENT_URL}/apply_for_entity_type/`;
export const EDIT_ENTITY_NAME_API_URL = `${ENTITY_MANAGEMENT_URL}/edit_entity_name_api/`;
export const GET_USER_PROFILE_DETAILS_API_URL = `${ENTITY_MANAGEMENT_URL}/get_user_profile_details/`;
export const LIST_ENTITY_PROFILES_API_URL = `${ENTITY_MANAGEMENT_API_URL}/list_entity_profiles_api/`;
export const LIST_APPLICATIONS_API_URL = `${ENTITY_MANAGEMENT_API_URL}/list_applications_api/`;
export const GET_MY_ASSIGNED_APPLICATIONS_API_URL = `${ENTITY_MANAGEMENT_API_URL}/get_my_assigned_applications_api/`;
export const LIST_APPLICATION_FORMS_API_URL = `${ENTITY_MANAGEMENT_API_URL}/list_application_forms_api/`;
export const GET_APPLICATION_FORM_API_URL = `${ENTITY_MANAGEMENT_API_URL}/get_application_form_api/`;
export const GET_APPLICATION_DOCUMENTS_API_URL = `${ENTITY_MANAGEMENT_API_URL}/get_application_documents_api/`;
export const GET_APPLICATION_TRANSITION_HISTORY_API_URL = `${ENTITY_MANAGEMENT_API_URL}/get_application_transition_history_api/`;
export const SUBMIT_APPLICATION_FORM_ANSWERS_API_URL = `${ENTITY_MANAGEMENT_API_URL}/submit_application_form_answers_api/`;
export const DASHBOARD_WORKFLOW_STATUS_COUNTS_API_URL = `${ENTITY_MANAGEMENT_API_URL}/dashboard_workflow_status_counts_api/`;
export const MANUAL_VERIFY_FORM_SECTION_API_URL = `${ENTITY_MANAGEMENT_API_URL}/manual_verify_form_section_api/`;
export const MANUAL_VERIFY_SECTION_QUESTION_API_URL = `${ENTITY_MANAGEMENT_API_URL}/manual_verify_section_question_api/`;
export const MANUAL_VERIFY_ADDITIONAL_DOCUMENT_URL = `${ENTITY_MANAGEMENT_URL}/_manual_verify_additional_document/`;

// SUB ENTITIES
export const CREATE_SUB_ENTITY_TYPE_URL = `${ENTITY_MANAGEMENT_URL}/create_sub_entity_type_api/`;
export const LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL = `${ENTITY_MANAGEMENT_URL}/list_assigned_child_entity_types_api/`;
export const UNASSIGN_SUB_ENTITY_TYPE_URL = `${ENTITY_MANAGEMENT_URL}/unassign_sub_entity_type_api/`;

// ENTITY CONFIG
const ENTITY_CONFIG_URL = `${GLOBAL_URL}/entity_config_api`;
export const CREATE_ENTITY_CONFIG_URL = `${ENTITY_CONFIG_URL}/create_entity_config_api/`;
export const LIST_ENTITY_CONFIGS_URL = `${ENTITY_CONFIG_URL}/list_entity_configs_api/`;
export const GET_FULL_CONFIG_BY_ENTITY_TYPE_URL = `${ENTITY_CONFIG_URL}/get_full_config_by_entity_type_api/`;
export const PREPARE_ONBOARDING_URL = `${ENTITY_CONFIG_URL}/prepare_onboarding_api/`;
export const EXECUTE_ONBOARDING_URL = `${ENTITY_CONFIG_URL}/execute_onboarding_api/`;
export const GET_ONBOARDING_DASHBOARD_URL = `${ENTITY_CONFIG_URL}/get_onboarding_dashboard_api/`;
export const GET_ONBOARDING_STATUS_URL = `${ENTITY_CONFIG_URL}/get_onboarding_status_api/`;
export const EVALUATE_ONBOARDING_COMPLIANCE_URL = `${ENTITY_CONFIG_URL}/evaluate_compliance_api/`;
export const CREATE_FORM_BINDING_URL = `${ENTITY_CONFIG_URL}/create_form_binding_api/`;
export const REMOVE_FORM_BINDING_URL = `${ENTITY_CONFIG_URL}/remove_form_binding_api/`;
export const CREATE_WORKFLOW_BINDING_URL = `${ENTITY_CONFIG_URL}/create_workflow_binding_api/`;
export const REMOVE_WORKFLOW_BINDING_URL = `${ENTITY_CONFIG_URL}/remove_workflow_binding_api/`;
export const CREATE_RULE_BINDING_URL = `${ENTITY_CONFIG_URL}/create_rule_binding_api/`;
export const REMOVE_RULE_BINDING_URL = `${ENTITY_CONFIG_URL}/remove_rule_binding_api/`;
export const CREATE_CHILD_REQUIREMENT_URL = `${ENTITY_CONFIG_URL}/create_child_requirement_api/`;
export const GET_CHILD_REQUIREMENTS_URL = `${ENTITY_CONFIG_URL}/get_child_requirements_api/`;
export const REMOVE_CHILD_REQUIREMENT_URL = `${ENTITY_CONFIG_URL}/remove_child_requirement_api/`;
export const BIND_VERIFICATION_SERVICES = `${ENTITY_CONFIG_URL}/create_verification_service_binding_api/`;
export const GET_VERIFICATION_SERVICE_BINDINGS = `${ENTITY_CONFIG_URL}/get_verification_service_bindings_api/`;

// MANUAL VERIFICATION (EntityConfig bindings)
export const CREATE_MANUAL_VERIFICATION_BINDING = `${ENTITY_CONFIG_URL}/create_manual_verification_binding_api/`;
export const GET_MANUAL_VERIFICATION_BINDINGS = `${ENTITY_CONFIG_URL}/get_manual_verification_bindings_api/`;
export const REMOVE_MANUAL_VERIFICATION_BINDING = `${ENTITY_CONFIG_URL}/remove_manual_verification_binding_api/`;
export const MANUAL_VERIFICATION_URLS = `${GLOBAL_URL}/manual_verification_api/`;
export const OPEN_MANUAL_VERIFICATION_RUN = `${MANUAL_VERIFICATION_URLS}open_manual_verification_run_api/`;
export const GET_MANUAL_VERIFICATION_RUN = `${MANUAL_VERIFICATION_URLS}get_manual_verification_run_api/`;
export const LIST_MANUAL_VERIFICATION_RUNS = `${MANUAL_VERIFICATION_URLS}list_manual_verification_runs_api/`;
export const RECORD_MANUAL_VERIFICATION_FIELD_RESULT = `${MANUAL_VERIFICATION_URLS}record_field_result_api/`;
export const RECORD_MANUAL_VERIFICATION_DECISION = `${MANUAL_VERIFICATION_URLS}record_decision_api/`;
export const START_BANK_STATEMENT_ANALYSIS_API = `${MANUAL_VERIFICATION_URLS}start_bank_statement_analysis_api/`;
export const REFRESH_BANK_STATEMENT_ANALYSIS_API = `${MANUAL_VERIFICATION_URLS}refresh_bank_statement_analysis_api/`;
export const GET_BANK_STATEMENT_ANALYSIS_API = `${MANUAL_VERIFICATION_URLS}get_bank_statement_analysis_api/`;
export const GET_MANUAL_VERIFICATION_HISTORY = `${MANUAL_VERIFICATION_URLS}get_verification_history_api/`;
export const GET_MANUAL_VERIFICATION_STATUS = `${MANUAL_VERIFICATION_URLS}get_verification_status_api/`;
export const GET_MANUAL_VERIFICATION_QUESTION_MAPPINGS_API =
  `${MANUAL_VERIFICATION_URLS}get_manual_verification_question_mappings_api/`;

export const GET_ONBOARDING_FORMS_API = `${ENTITY_CONFIG_URL}/get_onboarding_forms_api/`;
export const LINK_VERIFICATION_FORM_API = `${ENTITY_CONFIG_URL}/link_verification_form_api/`;
export const CREATE_ONBOARDING_VERIFICATION_QUESTION_MAPPINGS_API =
  `${ENTITY_CONFIG_URL}/create_onboarding_verification_question_mappings_api/`;
export const GET_ONBOARDING_VERIFICATION_QUESTION_MAPPINGS_API =
  `${ENTITY_CONFIG_URL}/get_onboarding_verification_question_mappings_api/`;
export const REMOVE_VERIFICATION_BINDING = `${ENTITY_CONFIG_URL}/remove_verification_service_binding_api/`;
export const GET_LINKED_ONBOARDING_FORMS_API = `${ENTITY_CONFIG_URL}/get_linked_onboarding_forms_api/`;
export const UNASSIGN_LINKED_ONBOARDING_FORMS_API = `${ENTITY_CONFIG_URL}/unlink_verification_form_api/`;

// WORKFLOW MANAGEMENT
const WORKFLOW_MANAGEMENT_URL = `${GLOBAL_URL}/workflow_management_api`;
export const CREATE_ENTITY_TYPE_WORKFLOW_URL = `${WORKFLOW_MANAGEMENT_URL}/create_entity_type_workflow/`;
export const UPDATE_ENTITY_TYPE_WORKFLOW_URL = `${WORKFLOW_MANAGEMENT_URL}/update_entity_type_workflow/`;
export const VIEW_ENTITY_TYPE_WORKFLOWS_URL = `${WORKFLOW_MANAGEMENT_URL}/view_entity_type_workflows/`;
export const VIEW_SELECTED_WORKFLOWS_URL = `${WORKFLOW_MANAGEMENT_URL}/view_selected_workflows/`;
export const MANAGE_FORM_WORKFLOW_URL = `${WORKFLOW_MANAGEMENT_URL}/manage_form_workflow/`;
export const MANAGE_WORKFLOW_STATUS_TRANSITIONS_URL = `${WORKFLOW_MANAGEMENT_URL}/manage_workflow_status_transitions/`;
export const ASSIGN_ENTITY_TYPE_WORKFLOW_FORM_URL = `${WORKFLOW_MANAGEMENT_URL}/assign_entity_type_workflow_form/`;
export const ASSIGN_ENTITY_TYPE_WORKFLOW_STATUS_URL = `${WORKFLOW_MANAGEMENT_URL}/assign_entity_type_workflow_status/`;
export const UNASSIGN_ENTITY_TYPE_WORKFLOW_STATUS_URL = `${WORKFLOW_MANAGEMENT_URL}/unassign_entity_type_workflow_status/`;
export const VIEW_ENTITY_TYPE_WORKFLOW_FORM_URL = `${WORKFLOW_MANAGEMENT_URL}/view_entity_type_workflow_form/`;
export const UNASSIGN_ENTITY_TYPE_WORKFLOW_FORM_URL = `${WORKFLOW_MANAGEMENT_URL}/unassign_entity_type_workflow_form/`;
export const GET_ASSIGN_FORM_STATUS_DATA_URL = `${WORKFLOW_MANAGEMENT_URL}/get_assign_form_status_data/`;
export const ASSIGN_FORM_STATUS_URL = `${WORKFLOW_MANAGEMENT_URL}/assign_form_status/`;
export const UNASSIGN_FORM_STATUS_URL = `${WORKFLOW_MANAGEMENT_URL}/unassign_form_status/`;
export const CREATE_WORKFLOW_STATUS_TRANSITION_RULE_URL = `${WORKFLOW_MANAGEMENT_URL}/create_workflow_status_transition_rule/`;
export const GET_FORM_WORKFLOW_TRANSITION_RULES_URL = `${WORKFLOW_MANAGEMENT_URL}/get_form_workflow_transition_rules/`;
export const LIST_FORM_TRANSITION_RULES_URL = `${WORKFLOW_MANAGEMENT_URL}/list_form_transition_rules/`;
export const TOGGLE_TRANSITION_RULE_DOCUMENT_URL = `${WORKFLOW_MANAGEMENT_URL}/toggle_transition_rule_document/`;
export const UPDATE_TRANSITION_RULE_URL = `${WORKFLOW_MANAGEMENT_URL}/update_transition_rule/`;
export const DELETE_TRANSITION_RULE_URL = `${WORKFLOW_MANAGEMENT_URL}/delete_transition_rule/`;
export const GET_ALL_TRANSITION_TYPES_URL = `${WORKFLOW_MANAGEMENT_URL}/get_all_transition_types/`;
export const CREATE_APPLICATION_STATUS_APPROVAL_LOG_URL = `${WORKFLOW_MANAGEMENT_URL}/create_application_status_approval_log/`;
export const CREATE_APPLICATION_TRANSITION_LOG_URL = `${WORKFLOW_MANAGEMENT_URL}/create_application_transition_log/`;
export const CREATE_WORKFLOW_STATUS_APPROVAL_RULE_URL = `${WORKFLOW_MANAGEMENT_URL}/create_workflow_status_approval_rule/`;
export const UPDATE_WORKFLOW_STATUS_APPROVAL_RULE_URL = `${WORKFLOW_MANAGEMENT_URL}/update_workflow_status_approval_rule/`;
export const DELETE_WORKFLOW_STATUS_APPROVAL_RULE_URL = `${WORKFLOW_MANAGEMENT_URL}/delete_workflow_status_approval_rule/`;
export const GET_USERS_BY_ROLE_URL = `${WORKFLOW_MANAGEMENT_URL}/get_users_by_role/`;
export const ASSIGN_STATUS_REVIEWERS_URL = `${WORKFLOW_MANAGEMENT_URL}/assign_status_reviewers/`;
export const GET_STATUS_REVIEWERS_URL = `${WORKFLOW_MANAGEMENT_URL}/get_status_reviewers/`;
export const UNASSIGN_STATUS_REVIEWERS_URL = `${WORKFLOW_MANAGEMENT_URL}/unassign_status_reviewers/`;
export const ASSIGN_SECTION_ACCESS_URL = `${WORKFLOW_MANAGEMENT_URL}/assign_section_access/`;
export const GET_SECTION_ACCESS_URL = `${WORKFLOW_MANAGEMENT_URL}/get_section_access/`;
export const UNASSIGN_SECTION_ACCESS_URL = `${WORKFLOW_MANAGEMENT_URL}/unassign_section_access/`;
export const CREATE_ACTION_URL = `${WORKFLOW_MANAGEMENT_URL}/create_action/`;
export const GET_ALL_ACTIONS_URL = `${WORKFLOW_MANAGEMENT_URL}/get_all_actions/`;
export const GET_ACTION_URL = `${WORKFLOW_MANAGEMENT_URL}/get_action/`;
export const UPDATE_ACTION_URL = `${WORKFLOW_MANAGEMENT_URL}/update_action/`;
export const DELETE_ACTION_URL = `${WORKFLOW_MANAGEMENT_URL}/delete_action/`;


// SURVEY MANAGEMENT
export const SURVEY_URLS = `${GLOBAL_URL}/survey_management/`;
export const CREATE_FORM_URL = `${SURVEY_URLS}create_form/`;
export const CREATE_MAIN_SECTION_URL = `${SURVEY_URLS}create_main_section_api/`;
export const DELETE_MAIN_SECTION_URL = `${SURVEY_URLS}delete_main_section_api/`;
export const UPDATE_MAIN_SECTION_URL = `${SURVEY_URLS}update_main_section_api/`;
export const REORDER_MAIN_SECTIONS_URL = `${SURVEY_URLS}reorder_main_sections_api/`;
export const CREATE_FORM_SECTION_URL = `${SURVEY_URLS}create_section_in_form/`;
export const SOFT_DELETE_FORM_SECTION_URL = `${SURVEY_URLS}delete_section/`;
export const REORDER_FORM_SECTION_URL = `${SURVEY_URLS}reorder_form_section_api/`;
export const GET_MAIN_SECTIONS_BY_FORM_URL = `${SURVEY_URLS}get_main_sections_by_form_api/`;
export const GET_FORM_STRUCTURE_URL = `${SURVEY_URLS}get_form_structure/`;
export const GET_FORM_TREE_URL = `${SURVEY_URLS}get_form_tree_api/`;
export const GET_ENTITY_TYPE_ASSIGNED_QUESTIONS_URL = `${SURVEY_URLS}get_entity_type_assigned_questions_api/`;
export const GET_ENTITY_TYPE_FORMS_URL = `${SURVEY_URLS}get_entity_type_forms/`;
export const UPDATE_FORM_SECTION_URL = `${SURVEY_URLS}update_form_section/`;
export const GET_FORM_SECTIONS_URL = `${SURVEY_URLS}get_form_sections/`;
export const CREATE_QUESTION_URL = `${SURVEY_URLS}create_form_question/`;
export const UPDATE_QUESTION_URL = `${SURVEY_URLS}update_question/`;
export const ASSIGN_DEPENDENT_QUESTION_URL = `${SURVEY_URLS}assign_dependent_question/`;
export const GET_DEPENDENT_QUESTIONS_URL = `${SURVEY_URLS}get_dependent_questions/`;
export const REORDER_SECTION_QUESTIONS_URL = `${SURVEY_URLS}reorder_section_questions_api/`;
export const ASSIGN_QUESTIONS_TO_SECTION_URL = `${SURVEY_URLS}assign_questions_to_section/`;
export const UNASSIGN_QUESTIONS_FROM_SECTION_URL = `${SURVEY_URLS}unassign_questions_from_section/`;
export const GET_QUESTIONS_IN_PROJECT_URL = `${SURVEY_URLS}get_questions_in_project/`;
export const GET_FORMS_URL = `${SURVEY_URLS}get_forms/`;
export const GET_PROFILE_COMPLETION_API_URL = `${SURVEY_URLS}get_profile_completion_api/`;

export const CREATE_FORM_STATUS_URL = `${SURVEY_URLS}create_form_status/`;
export const EDIT_FORM_STATUS_URL = `${SURVEY_URLS}edit_form_status/`;

// REPORT MANAGEMENT
const REPORT_MANAGEMENT_URL = `${GLOBAL_URL}/report_management`;
export const GET_ONBOARDING_REPORT_LOOKUPS_URL = `${REPORT_MANAGEMENT_URL}/get_case_report_lookups/`;
export const GET_ONBOARDING_REPORT_CONFIGURATION_URL = `${REPORT_MANAGEMENT_URL}/get_case_report_configuration/`;
export const SAVE_ONBOARDING_REPORT_CONFIGURATION_URL = `${REPORT_MANAGEMENT_URL}/save_case_report_configuration/`;
export const ONBOARDING_REPORT_DATA_URL = `${REPORT_MANAGEMENT_URL}/case_report_data/`;
export const CHECK_ONBOARDING_REPORT_URL = `${REPORT_MANAGEMENT_URL}/check_case_report/`;
export const GENERATE_ONBOARDING_REPORT_URL = `${REPORT_MANAGEMENT_URL}/generate_case_report/`;
export const GET_ONBOARDING_REPORT_HISTORY_URL = `${REPORT_MANAGEMENT_URL}/get_case_report_history/`;
export const GET_ONBOARDING_REPORT_AUDIT_TRAIL_URL = `${REPORT_MANAGEMENT_URL}/get_case_report_audit_trail/`;

// Foundation Services
export const GET_ALL_QUESTION_TYPES_URL = `${SURVEY_URLS}get_data_point_types/`;
export const GET_ALL_FORM_TYPES_URL = `${SURVEY_URLS}get_all_form_types/`;
export const GET_ALL_FORM_STATUSES_URL = `${SURVEY_URLS}view_form_statuses/`;

//Entity config
export const ENTITY_CONFIG_URLS = `${GLOBAL_URL}/entity_config_api/`;
export const CREATE_PROJECT_BINDINGS = `${ENTITY_CONFIG_URLS}create_project_config_binding_api/`;
export const GET_FULL_CONFIG = `${ENTITY_CONFIG_URLS}get_full_config_by_entity_type_api/`;
export const GET_PROJECT_BINDINGS = `${ENTITY_CONFIG_URLS}get_project_config_bindings_api/`;
export const REMOVE_PROJECT_BINDING_URL = `${ENTITY_CONFIG_URLS}remove_project_config_binding_api/`;



//Template Management URLS
export const TEMPLATE_URLS = `${GLOBAL_URL}/template_management/`;
export const UPLOAD_TEMPLATE_URL = `${TEMPLATE_URLS}upload_project_template/`;
export const LIST_TEMPLATE_VIEW_URL = `${TEMPLATE_URLS}list_project_templates/`;
export const GET_DOCUMENT_TYPES = `${TEMPLATE_URLS}get_document_types/`;
export const BIND_TEMPLATES_ENTITY_CONFIG = `${TEMPLATE_URLS}assign_template_entity_config/`;
export const UNASSIGN_TEMPLATE_BINDING = `${TEMPLATE_URLS}api/unassign_template_entity_config_api/`;
export const GET_TEMPLATE_ENTITY_CONFIG_BINDINGS_URL = `${TEMPLATE_URLS}api/get_template_entity_config_bindings_api/`;
export const GET_TEMPLATE_ENTITY_TYPE_SIGNERS_URL = `${TEMPLATE_URLS}api/template_entity_type_signers/`;
export const UPSERT_TEMPLATE_ENTITY_TYPE_SIGNERS_URL = `${TEMPLATE_URLS}api/template_entity_type_signers/configure/`;
export const GET_WORKFLOW_ENTITIES_FOR_ASSIGNMENT_URL = `${TEMPLATE_URLS}api/get_workflow_entities_for_assignment_api/`;
export const ASSIGN_USERS_TO_WORKFLOW_API_URL = `${TEMPLATE_URLS}api/assign_users_to_workflow_api/`;
export const GET_STEP_ASSIGNED_SIGNERS_API_URL = `${TEMPLATE_URLS}api/get_step_assigned_signers_api/`;
export const GET_WORKFLOWS_ASSIGNED_TO_ENTITY_TYPE_TEMPLATE_URL = `${TEMPLATE_URLS}api/get_workflows_assigned_to_entity_type_template/`;
export const GET_TEMPLATE_WORKFLOW_URL = `${TEMPLATE_URLS}api/get_workflow/`;
export const SEND_CONTRACT_URL = `${TEMPLATE_URLS}api/send_contract/`;
export const LIST_SENT_CONTRACTS_URL = `${TEMPLATE_URLS}api/list_sent_contracts/`;
export const TRACK_DOCUSEAL_SUBMISSION_URL = `${TEMPLATE_URLS}api/track_docuseal_submission/`;
export const DOWNLOAD_SIGNED_DOCUMENT_URL = `${TEMPLATE_URLS}download_signed_document/`;
export const CREATE_DOCUSEAL_SUBMISSION_PREVIEW_URL = (template_id) =>
  `${TEMPLATE_URLS}api/docuseal/templates/${template_id}/create-submission-preview/`;


// COMPLIANCE MANAGEMENT
const COMPLIANCE_MANAGEMENT_URL = `${GLOBAL_URL}/compliance_management_api`;
export const CREATE_COMPLIANCE_RULE_URL = `${COMPLIANCE_MANAGEMENT_URL}/create_compliance_rule_api/`;
export const GET_COMPLIANCE_RULES_URL = `${COMPLIANCE_MANAGEMENT_URL}/get_compliance_rules_api/`;
export const GET_FORM_COMPLIANCE_RULES_URL = `${COMPLIANCE_MANAGEMENT_URL}/get_form_compliance_rules_api/`;
export const UPDATE_COMPLIANCE_RULE_URL = `${COMPLIANCE_MANAGEMENT_URL}/update_compliance_rule_api/`;
export const DELETE_COMPLIANCE_RULE_URL = `${COMPLIANCE_MANAGEMENT_URL}/delete_compliance_rule_api/`;
export const GET_ENTITY_TYPE_FORMS_COMPLIANCE_URL = `${COMPLIANCE_MANAGEMENT_URL}/get_entity_type_forms_api/`;
export const GET_ASSIGNED_QUESTIONS_FOR_RULE_URL = `${COMPLIANCE_MANAGEMENT_URL}/get_assigned_questions_for_rule_api/`;
export const BULK_ASSIGN_COMPLIANCE_BY_SCOPE_URL = `${COMPLIANCE_MANAGEMENT_URL}/bulk_assign_by_scope_api/`;
export const BULK_ASSIGN_COMPLIANCE_QUESTIONS_URL = `${COMPLIANCE_MANAGEMENT_URL}/bulk_assign_questions_api/`;
export const BULK_UNASSIGN_COMPLIANCE_QUESTIONS_URL = `${COMPLIANCE_MANAGEMENT_URL}/bulk_unassign_questions_api/`;

//AUTO VERIFICATION
export const AUTO_VERIFICATION_URLS  = `${GLOBAL_URL}/auto_verification_api/`;
export const GET_VERIFICATION_SERVICES = `${AUTO_VERIFICATION_URLS}get_verification_services/`;
export const GET_VERIFICATION_FORMS = `${AUTO_VERIFICATION_URLS}get_verification_forms/`;
export const CREATE_VERIFICATION_FORM = `${AUTO_VERIFICATION_URLS}create_verification_form/`;
export const GET_MAPPING_OPTIONS = `${AUTO_VERIFICATION_URLS}get_mapping_options/`;
export const CREATE_SERVICE_MAPPINGS = `${AUTO_VERIFICATION_URLS}create_mappings/`;
export const GET_QUESTION_MAPPINGS = `${AUTO_VERIFICATION_URLS}get_question_mappings/`;
export const GET_VERIFICATION_LOGS = `${AUTO_VERIFICATION_URLS}get_verification_logs/`;
export const GET_VERIFICATION_STATUSES = `${AUTO_VERIFICATION_URLS}get_verification_statuses/`;

// auto_verification endpoints
export const AUTO_VERIFICATION_RUN_URLS  = `${GLOBAL_URL}/auto_verification/`;
export const RUN_KYC_VERIFICATION = `${AUTO_VERIFICATION_RUN_URLS}verify_kyc/`;
export const KYC_VERIFIED_DATA = `${AUTO_VERIFICATION_RUN_URLS}get_latest_kyc_result/`;
export const RUN_AML_VERIFICATION = `${AUTO_VERIFICATION_RUN_URLS}run_aml_verification/`;
export const AML_VERIFIED_DATA = `${AUTO_VERIFICATION_RUN_URLS}get_aml_results/`;
export const RUN_IDENTITY_VERIFICATION = `${AUTO_VERIFICATION_RUN_URLS}run_identity_verification/`;
export const IDV_VERIFIED_DATA = `${AUTO_VERIFICATION_RUN_URLS}get_idv_results/`;
export const RUN_CIPC_VERIFICATION = `${AUTO_VERIFICATION_RUN_URLS}run_cipc_verification/`;
export const CIPC_VERIFIED_DATA = `${AUTO_VERIFICATION_RUN_URLS}get_cipc_verification_results/`;
export const RUN_CREDIT_REPORT_VERIFICATION = `${AUTO_VERIFICATION_RUN_URLS}run_credit_report_verification/`;
export const CREDIT_REPORT_VERIFIED_DATA = `${AUTO_VERIFICATION_RUN_URLS}get_credit_report_results/`;

// IDENTITY FACIAL VERIFICATION
export const IDENTITY_FACIAL_VERIFICATION_API_URL = `${GLOBAL_URL}/identity_facial_verification_api/`;
export const FACIAL_VERIFICATION_HEALTH_URL = `${IDENTITY_FACIAL_VERIFICATION_API_URL}health/`;
export const CREATE_FACIAL_VERIFICATION_SESSION_URL = `${IDENTITY_FACIAL_VERIFICATION_API_URL}sessions/`;
export const UPLOAD_FACIAL_VERIFICATION_ID_DOCUMENT_URL = `${IDENTITY_FACIAL_VERIFICATION_API_URL}sessions/:session_id/id-document/`;
export const VERIFY_FACIAL_VERIFICATION_SESSION_URL = `${IDENTITY_FACIAL_VERIFICATION_API_URL}sessions/:session_id/verify/`;
export const FACIAL_VERIFICATION_RESULT_URL = `${IDENTITY_FACIAL_VERIFICATION_API_URL}result/`;


// RISK MATRIX MANAGEMENT
export const RISK_MATRIX_MANAGEMENT_URL = `${GLOBAL_URL}/risk_matrix_management_api`;
export const LIST_RISK_FRAMEWORKS_BY_PROJECT_URL = `${RISK_MATRIX_MANAGEMENT_URL}/list_risk_frameworks_by_project/`;
export const GET_ASSIGNED_QUESTIONS_TO_ASSESSMENT_URL = `${RISK_MATRIX_MANAGEMENT_URL}/get_assigned_questions_to_assessment/`;
export const GET_RISK_CHECKLIST_WEIGHTS_URL = `${RISK_MATRIX_MANAGEMENT_URL}/get_checklist_weights/`;
export const GET_SUBMITTED_RISK_ASSESSMENT_ANSWERS_URL = `${RISK_MATRIX_MANAGEMENT_URL}/get_submitted_assessment_answers/`;
export const SUBMIT_RISK_ASSESSMENT_ANSWERS_URL = `${RISK_MATRIX_MANAGEMENT_URL}/submit_assessment_answers/`;
export const GET_APPLICATION_RISK_HISTORY_URL = `${RISK_MATRIX_MANAGEMENT_URL}/get_application_risk_history/`;







